<template>
    <section>
        <ds-modal
            :is-open="isOpen"
            show-close
            :size="modalSize"
            :title.sync="title"
            data-qa="web-profile-view-all"
            @close="modalClose"
        >
            <div class="date-range-filter">
                <ds-date-picker
                    v-model="startDate"
                    name="basic"
                    label="From Date"
                    class="date-field"
                />

                <ds-date-picker
                    v-model="endDate"
                    name="basic"
                    label="To Date"
                    class="date-field"
                />

                <ds-filled-button class="filter-page-button" @click="loadVisitors(visitorId)">
                    {{ $options.FILTER_PAGE_VIEWS }}
                </ds-filled-button>
            </div>

            <contact-web-profile-table :viewed-urls="viewedUrls" />

            <ds-infinite-scroll
                v-if="isScrollEnabled"
                :limit="limit"
                :loading="loading"
                :no-more-data="noMoreData"
                data-qa="table-scroll"
                @load="handleInfiniteScrollLoad"
            >
                <ds-placeholder
                    v-for="i in 3"
                    :key="i"
                    :rows="placeholder"
                    class="placeholder"
                />
            </ds-infinite-scroll>
        </ds-modal>
    </section>
</template>
<script>
import ContactWebProfileTable from './ContactWebProfileTable';
import axios from 'axios';
import moment from 'moment';

const FILTER_PAGE_VIEWS = 'Filter Page Views';

export default {
    FILTER_PAGE_VIEWS,

    components: { ContactWebProfileTable },

    props: {
        visitorId: Number,
    },

    data() {
        return {
            isOpen: false,
            modalSize: 'xl',
            title: 'Page Views',
            viewedUrls: [],
            startDate: '',
            endDate: '',
            limit: 10,
            offSet: 0,
            url: '/app/webTracking/contactPageViews',
            loading: true,
            noMoreData: false,
            placeholder: [
                { height: '1rem', boxes: [2.4, 6, 2] },
            ],
        };
    },

    computed: {
        isScrollEnabled() {
            return this.viewedUrls?.length >= 10;
        },
    },

    methods: {
        showModal() {
            this.isOpen = true;
        },

        modalClose() {
            this.noMoreData = false;
            this.viewedUrls = [];
            this.startDate = '';
            this.endDate = '';
            this.isOpen = false;
        },

        async loadVisitors(visitorId) {
            const startDate = this.formattedDate(this.startDate);
            const endDate = this.formattedDate(this.endDate);

            this.offSet = 0;
            this.noMoreData = false;

            await axios.get(`${this.url}?visitorId=${visitorId}&dateRangeBegin=${startDate}&dateRangeEnd=${endDate}&offset=${this.offSet}`)
                .then((response) => {
                    this.viewedUrls = response.data;
                    this.offSet = 10;
                });
        },

        async loadVisitorsScroll() {
            try {
                const startDate = this.formattedDate(this.startDate);
                const endDate = this.formattedDate(this.endDate);

                const response = await axios.get(`${this.url}?visitorId=${this.visitorId}&dateRangeBegin=${startDate}&dateRangeEnd=${endDate}&offset=${this.offSet}`);
                const onScrollViewedUrls = response.data;

                this.offSet = onScrollViewedUrls.length + this.offSet;
                this.viewedUrls.push(...onScrollViewedUrls);

                if (onScrollViewedUrls.length < 10) {
                    this.noMoreData = true;
                }
            } catch (error) {
                this.$error({ message: 'Unable to get visitors data for this contact' });
            }
        },

        async handleInfiniteScrollLoad() {
            this.loading = true;

            await this.loadVisitorsScroll();
            this.loading = false;
        },

        formattedDate(date) {
            return date ? moment(date).format('YYYY-MM-DD') : '';
        },
    },
};
</script>

<style lang="scss" scoped>
.date-field {
    min-width: 8rem;
}

.date-range-filter {
    display: flex;
    justify-content: space-between;
    margin: 0 10%;
    white-space: nowrap;
    overflow-x: auto;
    padding-top: $spacing-200;

    @media ($small) {
        margin: initial;
    }
}

.filter-page-button {
    height: fit-content;
}

.placeholder {
    margin-bottom: $spacing-200;
}
</style>
